/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// console.log("Hello World! (from ultime-blocks-lights-mood block)");
/* eslint-enable no-console */

(function () {
    function initMoodLight() {
        const canvas = document.getElementById('mlCanvas');
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        const wrap = document.getElementById('mlPreviewWrap');
        const moodGrid = document.getElementById('mlMoodGrid');
        const colorListEl = document.getElementById('mlColorList');
        const addColorBtn = document.getElementById('mlAddColorBtn');
        const fadeModeEl = document.getElementById('mlFadeMode');
        const durationEl = document.getElementById('mlDuration');
        const fadeDurEl = document.getElementById('mlFadeDuration');
        const brightnessEl = document.getElementById('mlBrightness');
        const orderEl = document.getElementById('mlOrder');
        const showLabelEl = document.getElementById('mlShowLabel');
        const toggleBtn = document.getElementById('mlToggleBtn');
        const resetBtn = document.getElementById('mlResetBtn');
        const moodLabel = document.getElementById('mlMoodLabel');
        const progressBar = document.getElementById('mlProgressBar');
        const fullscreenBtn = document.getElementById('mlFullscreenBtn');
        const fsExpand = document.getElementById('mlFsExpand');
        const fsCompress = document.getElementById('mlFsCompress');
        const cpPopup = document.getElementById('mlCpPopup');
        const cpSwatch = document.getElementById('mlCpSwatch');
        const cpHex = document.getElementById('mlCpHex');
        const cpCopy = document.getElementById('mlCpCopy');
        const cpPaste = document.getElementById('mlCpPaste');
        const cpAdd = document.getElementById('mlCpAdd');
        const cpCancel = document.getElementById('mlCpCancel');

        let running = false, rafId = null;
        let cw = 0, ch = 0, dpr = 1;
        let colors = [], sequence = [], seqIdx = 0;
        let phase = 'hold', phaseT = 0, lastTs = null;
        let currentIdx = 0, nextIdx = 1;
        let activeMood = null;

        const MOODS = [
            { id: 'zen', emoji: '🧘', name: 'Zen', desc: 'Wholeness', dur: 6, fade: 3, mode: 'gradient-r', order: 'pingpong', colors: ['#e8f4f8', '#c9e8f0', '#a8d8e8', '#7ec8d8', '#5bb8cc', '#3aa8bc', '#1a98ac', '#0088a0', '#006080', '#004060'] },
            { id: 'calm', emoji: '😌', name: 'Calm', desc: 'Serenity', dur: 5, fade: 3, mode: 'gradient-v', order: 'pingpong', colors: ['#dbe9f4', '#c2d9ed', '#a8c8e6', '#8eb8df', '#74a8d8', '#5a98d1', '#4088c4', '#2678b7', '#0c68aa', '#00589d'] },
            { id: 'sleep', emoji: '😴', name: 'Sleep', desc: 'Falling asleep', dur: 8, fade: 5, mode: 'solid', order: 'sequence', colors: ['#1a0a2e', '#16082a', '#120626', '#0e0422', '#0a031e', '#08021a', '#060116', '#040112', '#02000e', '#00000a'] },
            { id: 'meditate', emoji: '☮️', name: 'Meditation', desc: 'Inwardness', dur: 7, fade: 4, mode: 'gradient-r', order: 'pingpong', colors: ['#4a0e8f', '#5c1fa8', '#6e30c1', '#7a40c8', '#8650cf', '#9260d6', '#9e70dd', '#aa80e4', '#b690eb', '#c2a0f2'] },
            { id: 'breathe', emoji: '🌬️', name: 'Breathing', desc: 'Cardiac coherence', dur: 4, fade: 2, mode: 'gradient-r', order: 'pingpong', colors: ['#e8f5e9', '#c8e6c9', '#a5d6a7', '#81c784', '#66bb6a', '#4caf50', '#43a047', '#388e3c', '#2e7d32', '#1b5e20'] },
            { id: 'focus', emoji: '🎯', name: 'Focus', desc: 'Mental clarity', dur: 4, fade: 1.5, mode: 'solid', order: 'sequence', colors: ['#e3f2fd', '#bbdefb', '#90caf9', '#64b5f6', '#42a5f5', '#2196f3', '#1e88e5', '#1976d2', '#1565c0', '#0d47a1'] },
            { id: 'energy', emoji: '⚡', name: 'Energy', desc: 'Vitality boost', dur: 2, fade: 0.8, mode: 'gradient-d', order: 'random', colors: ['#fff176', '#ffee58', '#fdd835', '#fbc02d', '#f9a825', '#ff8f00', '#ff6f00', '#e65100', '#bf360c', '#ff1744'] },
            { id: 'workout', emoji: '💪', name: 'Workout', desc: 'Power', dur: 1.5, fade: 0.5, mode: 'gradient-h', order: 'random', colors: ['#ff1744', '#ff4081', '#f50057', '#d500f9', '#651fff', '#3d5afe', '#2979ff', '#00b0ff', '#00e5ff', '#1de9b6'] },
            { id: 'creative', emoji: '🎨', name: 'Creativity', desc: 'Inspiration', dur: 3, fade: 1.5, mode: 'gradient-d', order: 'random', colors: ['#ff6ec7', '#ff9a3c', '#ffe156', '#43e97b', '#4facfe', '#a855f7', '#f093fb', '#ff6b6b', '#feca57', '#48dbfb'] },
            { id: 'study', emoji: '📚', name: 'Study', desc: 'Learning', dur: 5, fade: 2, mode: 'solid', order: 'pingpong', colors: ['#fafafa', '#f5f5f5', '#eeeeee', '#e0e0e0', '#bdbdbd', '#e8f5e9', '#c8e6c9', '#a5d6a7', '#81c784', '#66bb6a'] },
            { id: 'happy', emoji: '😊', name: 'Happiness', desc: 'Joy & lightness', dur: 2.5, fade: 1, mode: 'gradient-h', order: 'sequence', colors: ['#ffec00', '#ffcd00', '#ffbe00', '#ffaa00', '#ff9500', '#ff8000', '#ff7043', '#ff5722', '#ff6d00', '#ffd600'] },
            { id: 'love', emoji: '❤️', name: 'Love', desc: 'Tenderness', dur: 3, fade: 2, mode: 'gradient-r', order: 'pingpong', colors: ['#fce4ec', '#f8bbd0', '#f48fb1', '#f06292', '#ec407a', '#e91e63', '#d81b60', '#c2185b', '#ad1457', '#880e4f'] },
            { id: 'nostalgic', emoji: '🌅', name: 'Nostalgia', desc: 'Past sweetness', dur: 5, fade: 3, mode: 'gradient-d', order: 'pingpong', colors: ['#ffe0b2', '#ffcc80', '#ffb74d', '#ffa726', '#ff9800', '#fb8c00', '#ef6c00', '#e65100', '#c85250', '#a1453d'] },
            { id: 'melancholy', emoji: '🌧️', name: 'Melancholy', desc: 'Introspection', dur: 6, fade: 4, mode: 'gradient-v', order: 'pingpong', colors: ['#546e7a', '#607d8b', '#4a6572', '#37474f', '#455a64', '#546e7a', '#78909c', '#90a4ae', '#b0bec5', '#cfd8dc'] },
            { id: 'romantic', emoji: '🌹', name: 'Romantic', desc: 'Intimate mood', dur: 4, fade: 2.5, mode: 'gradient-r', order: 'pingpong', colors: ['#880e4f', '#ad1457', '#c2185b', '#d81b60', '#e91e63', '#f06292', '#f48fb1', '#ff80ab', '#ff4081', '#f50057'] },
            { id: 'anxious', emoji: '😤', name: 'Relaxation', desc: 'Anti-stress', dur: 7, fade: 5, mode: 'gradient-v', order: 'pingpong', colors: ['#e8f5e9', '#dcedc8', '#f0f4c3', '#fff9c4', '#fff8e1', '#fff3e0', '#fce4ec', '#f8bbd0', '#e1bee7', '#e8eaf6'] },
            { id: 'morning', emoji: '🌄', name: 'Morning', desc: 'Gentle wake-up', dur: 4, fade: 2.5, mode: 'gradient-v', order: 'sequence', colors: ['#1a237e', '#283593', '#3949ab', '#7986cb', '#ffb74d', '#ffa726', '#ff9800', '#ffe082', '#fff9c4', '#ffffff'] },
            { id: 'sunset2', emoji: '🌇', name: 'Sunset', desc: 'End of day', dur: 4, fade: 2.5, mode: 'gradient-v', order: 'pingpong', colors: ['#4a148c', '#6a1b9a', '#ff6f00', '#ff8f00', '#ffa000', '#ffb300', '#ffca28', '#ff7043', '#e64a19', '#bf360c'] },
            { id: 'night', emoji: '🌙', name: 'Night', desc: 'Evening watch', dur: 5, fade: 3, mode: 'gradient-v', order: 'pingpong', colors: ['#000033', '#000044', '#000066', '#000088', '#0000aa', '#1a006e', '#0d003b', '#08002a', '#04001a', '#02000d'] },
            { id: 'nature', emoji: '🌿', name: 'Nature', desc: 'Forest & earth', dur: 5, fade: 3, mode: 'gradient-v', order: 'pingpong', colors: ['#1b5e20', '#2e7d32', '#388e3c', '#43a047', '#4caf50', '#66bb6a', '#81c784', '#33691e', '#558b2f', '#689f38'] },
            { id: 'ocean', emoji: '🌊', name: 'Ocean', desc: 'Waves & calm', dur: 5, fade: 3, mode: 'gradient-h', order: 'pingpong', colors: ['#01579b', '#0277bd', '#0288d1', '#039be5', '#03a9f4', '#29b6f6', '#4fc3f7', '#006064', '#00838f', '#0097a7'] },
            { id: 'fire2', emoji: '🔥', name: 'Fire', desc: 'Burning heat', dur: 2, fade: 1, mode: 'gradient-v', order: 'random', colors: ['#bf360c', '#d84315', '#e64a19', '#f4511e', '#ff5722', '#ff7043', '#ff8a65', '#ff9800', '#ffa726', '#ffcc02'] },
            { id: 'aurora2', emoji: '🌌', name: 'Aurora', desc: 'Polar sky', dur: 4, fade: 2.5, mode: 'gradient-h', order: 'pingpong', colors: ['#00c853', '#00e676', '#69f0ae', '#00bfa5', '#1de9b6', '#00b0ff', '#40c4ff', '#651fff', '#d500f9', '#aa00ff'] },
            { id: 'spa', emoji: '🧖', name: 'Spa', desc: 'Body wellness', dur: 6, fade: 4, mode: 'gradient-r', order: 'pingpong', colors: ['#e0f7fa', '#b2ebf2', '#80deea', '#4dd0e1', '#26c6da', '#a5d6a7', '#c8e6c9', '#dcedc8', '#f0f4c3', '#fff9c4'] },
            { id: 'spring', emoji: '🌸', name: 'Spring', desc: 'Blossoming', dur: 4, fade: 2, mode: 'gradient-d', order: 'sequence', colors: ['#fce4ec', '#f8bbd0', '#f48fb1', '#ffccbc', '#ffe0b2', '#c8e6c9', '#dcedc8', '#f0f4c3', '#e1bee7', '#b39ddb'] },
            { id: 'summer', emoji: '☀️', name: 'Summer', desc: 'Summer heat', dur: 3, fade: 1.5, mode: 'gradient-d', order: 'sequence', colors: ['#ffeb3b', '#ffc107', '#ff9800', '#ff5722', '#4caf50', '#00bcd4', '#03a9f4', '#ff80ab', '#ff6d00', '#76ff03'] },
            { id: 'autumn', emoji: '🍂', name: 'Autumn', desc: 'Russet leaves', dur: 4, fade: 2.5, mode: 'gradient-d', order: 'pingpong', colors: ['#bf360c', '#e64a19', '#f4511e', '#ff7043', '#ff8a65', '#ffa000', '#ffb300', '#ffca28', '#795548', '#6d4c41'] },
            { id: 'winter', emoji: '❄️', name: 'Winter', desc: 'Crystalline cold', dur: 6, fade: 4, mode: 'gradient-v', order: 'pingpong', colors: ['#e3f2fd', '#bbdefb', '#90caf9', '#64b5f6', '#42a5f5', '#e1f5fe', '#b3e5fc', '#81d4fa', '#4fc3f7', '#e0f7fa'] },
        ];

        function buildMoodGrid() {
            moodGrid.innerHTML = '';
            MOODS.forEach(mood => {
                const card = document.createElement('div');
                card.className = 'mood-card';
                card.dataset.id = mood.id;

                const prev = document.createElement('canvas');
                prev.className = 'mood-preview';
                prev.width = 260; prev.height = 52;
                const pctx = prev.getContext('2d');
                const g = pctx.createLinearGradient(0, 0, 260, 0);
                const step = 1 / (mood.colors.length - 1);
                mood.colors.forEach((c, i) => g.addColorStop(Math.min(i * step, 1), c));
                pctx.fillStyle = g; pctx.fillRect(0, 0, 260, 52);

                const body = document.createElement('div');
                body.className = 'mood-body';
                body.innerHTML = `<div class="mood-emoji">${mood.emoji}</div><div class="mood-name">${mood.name}</div><div class="mood-desc">${mood.desc}</div>`;

                card.appendChild(prev); card.appendChild(body);
                card.addEventListener('click', () => loadMood(mood));
                moodGrid.appendChild(card);
            });
        }

        function loadMood(mood) {
            moodGrid.querySelectorAll('.mood-card').forEach(c => c.classList.remove('active'));
            moodGrid.querySelector(`.mood-card[data-id="${mood.id}"]`).classList.add('active');
            activeMood = mood;
            colors = [...mood.colors];
            renderColorList();
            durationEl.value = Math.min(Math.max(mood.dur, 0.5), 20);
            fadeDurEl.value = Math.min(Math.max(mood.fade, 0.1), 10);
            fadeModeEl.value = mood.mode;
            orderEl.value = mood.order;
            document.getElementById('mlDurationVal').textContent = `${durationEl.value}s`;
            document.getElementById('mlFadeDurationVal').textContent = `${fadeDurEl.value}s`;
            moodLabel.textContent = `${mood.emoji}  ${mood.name} — ${mood.desc}`;
            rebuildSequence();
            if (running) { lastTs = null; }
        }

        function openPopup(anchorEl) {
            cpPopup.classList.add('open');
            const rect = anchorEl.getBoundingClientRect();
            const popW = cpPopup.offsetWidth || 230;
            const popH = cpPopup.offsetHeight || 145;
            const margin = 8;
            let top = rect.bottom + margin;
            let left = rect.left;
            if (left + popW > window.innerWidth - margin) left = window.innerWidth - popW - margin;
            if (left < margin) left = margin;
            if (top + popH > window.innerHeight - margin) top = rect.top - popH - margin;
            if (top < margin) top = margin;
            cpPopup.style.top = `${top}px`;
            cpPopup.style.left = `${left}px`;
            setTimeout(() => cpHex.focus(), 50);
        }

        function closePopup() { cpPopup.classList.remove('open'); }

        document.addEventListener('click', e => {
            if (cpPopup.classList.contains('open') && !cpPopup.contains(e.target) && e.target !== addColorBtn) closePopup();
        });

        cpSwatch.addEventListener('input', () => { cpHex.value = cpSwatch.value.toUpperCase(); });
        cpHex.addEventListener('input', () => {
            let v = cpHex.value.trim();
            if (!v.startsWith('#')) v = '#' + v;
            if (/^#[0-9a-fA-F]{6}$/.test(v)) cpSwatch.value = v;
        });

        cpCopy.addEventListener('click', () => {
            navigator.clipboard.writeText(cpSwatch.value.toUpperCase()).then(() => {
                cpCopy.textContent = '✓ Copied';
                setTimeout(() => cpCopy.textContent = 'Copy', 1600);
            }).catch(() => {
                cpHex.select();
                document.execCommand('copy');
                cpCopy.textContent = '✓ Copied';
                setTimeout(() => cpCopy.textContent = 'Copy', 1600);
            });
        });

        cpPaste.addEventListener('click', async () => {
            try {
                let text = await navigator.clipboard.readText();
                text = text.trim();
                const hex = text.startsWith('#') ? text : '#' + text;
                if (/^#[0-9a-fA-F]{6}$/.test(hex)) {
                    cpSwatch.value = hex;
                    cpHex.value = hex.toUpperCase();
                } else {
                    cpPaste.textContent = '✗ Invalid';
                    setTimeout(() => cpPaste.textContent = 'Paste', 1600);
                }
            } catch {
                cpPaste.textContent = '✗ Error';
                setTimeout(() => cpPaste.textContent = 'Paste', 1600);
            }
        });

        cpAdd.addEventListener('click', () => {
            let v = cpHex.value.trim();
            if (!v.startsWith('#')) v = '#' + v;
            const hex = /^#[0-9a-fA-F]{6}$/.test(v) ? v : cpSwatch.value;
            colors.push(hex.toLowerCase());
            renderColorList();
            rebuildSequence();
            activeMood = null;
            moodGrid.querySelectorAll('.mood-card').forEach(c => c.classList.remove('active'));
            moodLabel.textContent = '🎨  Custom palette';
            closePopup();
        });

        cpCancel.addEventListener('click', closePopup);
        addColorBtn.addEventListener('click', e => { e.stopPropagation(); openPopup(addColorBtn); });

        function renderColorList() {
            colorListEl.querySelectorAll('.color-chip').forEach(el => el.remove());
            colors.forEach((hex, i) => {
                const chip = document.createElement('div');
                chip.className = 'color-chip';
                chip.style.background = hex;
                chip.title = hex.toUpperCase();
                const rm = document.createElement('span');
                rm.className = 'remove-btn';
                rm.textContent = '×';
                rm.addEventListener('click', e => {
                    e.stopPropagation();
                    if (colors.length > 2) { colors.splice(i, 1); renderColorList(); rebuildSequence(); }
                });
                chip.appendChild(rm);
                colorListEl.insertBefore(chip, addColorBtn);
            });
        }

        function rebuildSequence() {
            const n = colors.length;
            if (n < 2) { sequence = [0, 1]; currentIdx = 0; nextIdx = 1; return; }
            const ord = orderEl.value;
            if (ord === 'random') {
                sequence = Array.from({ length: Math.max(n * 3, 12) }, () => Math.floor(Math.random() * n));
            } else if (ord === 'pingpong') {
                sequence = [];
                for (let i = 0; i < n - 1; i++) sequence.push(i);
                for (let i = n - 1; i > 0; i--) sequence.push(i);
            } else {
                sequence = Array.from({ length: n }, (_, i) => i);
            }
            seqIdx = 0;
            currentIdx = sequence[0];
            nextIdx = sequence[1 % sequence.length];
            phase = 'hold';
            phaseT = 0;
        }

        orderEl.addEventListener('change', rebuildSequence);

        function resize() {
            dpr = window.devicePixelRatio || 1;
            cw = wrap.clientWidth;
            ch = wrap.clientHeight;
            if (!cw || !ch) { setTimeout(resize, 50); return; }
            canvas.width = Math.round(cw * dpr);
            canvas.height = Math.round(ch * dpr);
            ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        }

        new ResizeObserver(() => resize()).observe(wrap);

        function hexToRgb(hex) {
            const r = parseInt(hex.slice(1, 3), 16),
                g = parseInt(hex.slice(3, 5), 16),
                b = parseInt(hex.slice(5, 7), 16);
            return [r, g, b];
        }

        function applyBrightness(r, g, b, br) {
            const f = br / 100;
            return [Math.round(r * f), Math.round(g * f), Math.round(b * f)];
        }

        function lerpColor(c1, c2, t) {
            return c1.map((v, i) => Math.round(v + (c2[i] - v) * t));
        }

        function drawFrame(c1rgb, c2rgb, t, mode, br) {
            const [r1, g1, b1] = applyBrightness(...c1rgb, br);
            const [r2, g2, b2] = applyBrightness(...c2rgb, br);
            const col1 = `rgb(${r1},${g1},${b1})`;
            const col2 = `rgb(${r2},${g2},${b2})`;

            if (mode === 'solid') {
                const [rm, gm, bm] = lerpColor([r1, g1, b1], [r2, g2, b2], t);
                ctx.fillStyle = `rgb(${rm},${gm},${bm})`;
                ctx.fillRect(0, 0, cw, ch);
            } else if (mode === 'gradient-h') {
                const g = ctx.createLinearGradient(0, 0, cw, 0);
                g.addColorStop(0, col1); g.addColorStop(1, col2);
                ctx.fillStyle = g; ctx.fillRect(0, 0, cw, ch);
            } else if (mode === 'gradient-v') {
                const g = ctx.createLinearGradient(0, 0, 0, ch);
                g.addColorStop(0, col1); g.addColorStop(1, col2);
                ctx.fillStyle = g; ctx.fillRect(0, 0, cw, ch);
            } else if (mode === 'gradient-r') {
                const g = ctx.createRadialGradient(cw / 2, ch / 2, 0, cw / 2, ch / 2, Math.max(cw, ch) / 1.5);
                g.addColorStop(0, col1); g.addColorStop(1, col2);
                ctx.fillStyle = g; ctx.fillRect(0, 0, cw, ch);
            } else if (mode === 'gradient-d') {
                const g = ctx.createLinearGradient(0, 0, cw, ch);
                g.addColorStop(0, col1); g.addColorStop(1, col2);
                ctx.fillStyle = g; ctx.fillRect(0, 0, cw, ch);
            }
        }

        function easeInOut(t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; }

        function frame(ts) {
            if (!running) return;
            if (lastTs === null) lastTs = ts;
            const dt = Math.min((ts - lastTs) / 1000, 0.1);
            lastTs = ts;

            const dur = parseFloat(durationEl.value);
            const fadeDur = parseFloat(fadeDurEl.value);
            const br = parseFloat(brightnessEl.value);
            const mode = fadeModeEl.value;

            if (colors.length < 2) { rafId = requestAnimationFrame(frame); return; }

            phaseT += dt;

            if (phase === 'hold') {
                const holdDur = Math.max(dur - fadeDur, 0.05);
                const progress = Math.min(phaseT / holdDur, 1);
                progressBar.style.width = `${progress * 100}%`;
                const c1 = hexToRgb(colors[currentIdx] || '#000000');
                const c2 = hexToRgb(colors[currentIdx] || '#000000');
                drawFrame(c1, c2, 0, mode, br);
                if (phaseT >= holdDur) { phase = 'fade'; phaseT = 0; }
            } else {
                const t = easeInOut(Math.min(phaseT / fadeDur, 1));
                const c1 = hexToRgb(colors[currentIdx] || '#000000');
                const c2 = hexToRgb(colors[nextIdx] || '#000000');
                drawFrame(c1, c2, t, mode, br);
                progressBar.style.width = `100%`;
                if (phaseT >= fadeDur) {
                    seqIdx = (seqIdx + 1) % sequence.length;
                    currentIdx = sequence[seqIdx];
                    nextIdx = sequence[(seqIdx + 1) % sequence.length];
                    phase = 'hold';
                    phaseT = 0;
                    if (showLabelEl.value === '1') {
                        moodLabel.style.opacity = '1';
                        setTimeout(() => { moodLabel.style.opacity = '0'; }, 2000);
                    }
                }
            }

            rafId = requestAnimationFrame(frame);
        }

        function start() {
            if (colors.length < 2) {
                alert('Select a mood or add at least 2 colors.');
                return;
            }
            if (running) return;
            running = true;
            lastTs = null;
            toggleBtn.textContent = 'Pause';
            rebuildSequence();
            rafId = requestAnimationFrame(frame);
        }

        function pause() {
            running = false;
            if (rafId) cancelAnimationFrame(rafId);
            rafId = null;
            lastTs = null;
            toggleBtn.textContent = 'Resume';
        }

        function reset() {
            running = false;
            if (rafId) cancelAnimationFrame(rafId);
            rafId = null;
            lastTs = null;
            phaseT = 0;
            phase = 'hold';
            progressBar.style.width = '0%';
            ctx.clearRect(0, 0, cw, ch);
            toggleBtn.textContent = 'Start';
            moodGrid.querySelectorAll('.mood-card').forEach(c => c.classList.remove('active'));
            colors = [];
            activeMood = null;
            renderColorList();
            moodLabel.style.opacity = '0';
        }

        toggleBtn.addEventListener('click', () => running ? pause() : start());
        resetBtn.addEventListener('click', reset);

        durationEl.addEventListener('input', () => {
            document.getElementById('mlDurationVal').textContent = `${durationEl.value}s`;
        });
        fadeDurEl.addEventListener('input', () => {
            document.getElementById('mlFadeDurationVal').textContent = `${fadeDurEl.value}s`;
        });
        brightnessEl.addEventListener('input', () => {
            document.getElementById('mlBrightnessVal').textContent = `${brightnessEl.value}%`;
        });

        fullscreenBtn.addEventListener('click', () => {
            if (!document.fullscreenElement) wrap.requestFullscreen().catch(() => { });
            else document.exitFullscreen().catch(() => { });
        });

        document.addEventListener('fullscreenchange', () => {
            const fs = !!document.fullscreenElement;
            fsExpand.style.display = fs ? 'none' : 'block';
            fsCompress.style.display = fs ? 'block' : 'none';
            fullscreenBtn.setAttribute('aria-label', fs ? 'Exit full screen' : 'Full screen');
            wrap.classList.toggle('is-fullscreen-active', fs);
            setTimeout(resize, 30);
        });

        resize();
        buildMoodGrid();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMoodLight);
    else initMoodLight();
}());